import { INTL_LOCALES, toLocale } from '@/shared/lib/i18n';
import { resolveTopicVocabulary } from '@/entities/topic';
import type { DialogueSummary } from './types';

/** i18next locale = язык интерфейса — по нему день недели/месяц берутся на нужном языке. */
export function toIntlLocale(language: string): string {
  return INTL_LOCALES[toLocale(language)];
}

/** «Сегодня в 14:30», «Вчера», день недели за неделю, иначе дата — как в Telegram. */
export function formatDialogueWhen(iso: string, locale: string, yesterdayLabel: string): string {
  const date = new Date(iso);
  const now = new Date();
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const daysAgo = Math.round((startOfDay(now) - startOfDay(date)) / 86_400_000);

  if (daysAgo === 0) return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  if (daysAgo === 1) return yesterdayLabel;
  if (daysAgo > 1 && daysAgo < 7) return date.toLocaleDateString(locale, { weekday: 'short' });
  return date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
}

/**
 * Заголовок разговора — чем он отличается от других с тем же тьютором. Тема с
 * рулетки идёт вперёд общего «Свободного разговора»: подтема и есть предмет
 * разговора, и по ней он узнаётся в списке (см. `Dialogue.topic`,
 * `entities/topic`). Каталог мог поехать с тех пор, как разговор был начат, —
 * тогда `resolveTopicVocabulary` вернёт `undefined` и заголовок останется
 * общим (`fallback`).
 *
 * `fallback` пришёл параметром, а не через `t()` внутри: вызывающая сторона
 * может быть в любом i18n-namespace (`HistoryPage`, домашний виджет), и эта
 * функция не должна знать, из какого именно.
 */
export function dialogueTitle(
  item: DialogueSummary,
  lang: string,
  fallback: { lesson: string; freeConversation: string },
): string {
  if (item.practiceTitle) return item.practiceTitle;
  const topic = resolveTopicVocabulary(item.topic?.id, item.topic?.subtopicIndex, lang);
  if (topic) return topic.subtopicLabel;
  return item.scenario === 'lesson' ? fallback.lesson : fallback.freeConversation;
}
